import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  pressableBackground: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    position: 'absolute',
  },

  container: {
    borderRadius: 24,
    backgroundColor: '#EBEBEB',
    width: 550,
    padding: 30,
    alignItems: 'center',
  },

  imageRanking: {
    position: 'absolute',
    height: 108,
    width: 108,
    left: 26,
  },

  viewLine: {
    height: 5,
    width: '100%',
    backgroundColor: '#E6B25D',
  },

  title: {
    fontSize: 32,
    color: '#E6B25D',
    fontFamily: 'JockeyOne',
    alignSelf: 'flex-end',
  },

  viewHeader: {
    flexDirection: 'row',
    width: '100%',
    marginTop: 20,
  },

  textHeader: {
    fontSize: 14,
    color: '#E9B664',
    fontFamily: 'JockeyOne',
  },
});
